import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAnalytics } from "../hooks/useAnalytics";

/**
 * Fires a GA4 page_view on every route change. Required because this is an
 * SPA — GA4's default "enhanced measurement" page_view only fires on the
 * initial full page load, not on react-router navigations.
 *
 * Renders nothing. Mount once, inside the Router, e.g. in App.js next to
 * TopProgressBar/PrefetchManager.
 */
const AutoPageTracker = () => {
  const location = useLocation();
  const { trackPageView } = useAnalytics();

  useEffect(() => {
    trackPageView(location.pathname + location.search, document.title);
  }, [location.pathname, location.search, trackPageView]);

  return null;
};

export default AutoPageTracker;
